import React, { Component } from 'react';
import Frame from "./Frame";
import Paginator from "./Paginator";

class FrameContainer extends Component {
  constructor(props) {
    super(props);
    this.render = this.render.bind(this);
    this.state = {
      filteredFrames: null,
      framesPerPage: 500,
      currentPage: 1,
      pages: 1,
    }
  }

  changePage = (page) => {
    this.setState({
      currentPage: page,
    });
  };

  filtersEqual(a, b) {
    if (a === b) return true;
    if (!a || !b) return a === b;
    const aFt = a.frameTypes || [];
    const bFt = b.frameTypes || [];
    const aPi = a.plugIDs || [];
    const bPi = b.plugIDs || [];
    const aMb = a.mbusSecAddresses || [];
    const bMb = b.mbusSecAddresses || [];
    return aFt.length === bFt.length && aFt.every((v, i) => v === bFt[i])
        && aPi.length === bPi.length && aPi.every((v, i) => v === bPi[i])
        && aMb.length === bMb.length && aMb.every((v, i) => v === bMb[i]);
  }

  componentDidUpdate(prevProps) {
    const framesChanged = prevProps.frames !== this.props.frames;
    const filtersChanged = !this.filtersEqual(prevProps.filters, this.props.filters);

    if (!framesChanged && !filtersChanged) {
      return;
    }

    console.log("FrameContainer will update. frames:");
    console.log(this.props.frames);

    if (!this.props.frames) {
      this.setState({ filteredFrames: null });
      return;
    }

    let frameTypes = [];
    let plugIDs = [];
    let mbusSecAddresses = [];
    if (this.props.filters != null) {
      frameTypes = this.props.filters['frameTypes'];
      plugIDs = this.props.filters['plugIDs'];
      mbusSecAddresses = this.props.filters['mbusSecAddresses'];
    }
    this.filterFrames(this.props.frames.lines, frameTypes, plugIDs, mbusSecAddresses);
  }

  filterFrames = (lines, frameTypes, plugIDs, mbusSecAddresses) => {
    if (!lines) {
      return;
    }

    console.log("Filtering frames. Before:");
    console.log({lines});
    const filteredFrames = lines
      .filter((frame => {
        if (frameTypes.length === 0) {
          return true;
        }
        return frameTypes.includes(frame.frame_type);
      }))
      .filter((frame => {
        if (plugIDs.length === 0) {
          return true;
        }
        return plugIDs.includes(frame.plugid);
      }))
      .filter((frame => {
        if (!mbusSecAddresses || mbusSecAddresses.length === 0) {
          return true;
        }
        return frame.payload && frame.payload.some(([key, value]) =>
          key === 'mbus_secondary_addr' && mbusSecAddresses.includes(String(value))
        );
      }));

    console.log({filteredFrames});
    this.setState({
      filteredFrames,
      num_frames: filteredFrames.length,
      pages: Math.ceil(filteredFrames.length / this.state.framesPerPage),
    })
  };

  render() {
    // {this.state.frames.map(frame => <Frame frame={frame} />)}
    console.log("Rendering frame container");
    console.log({StateFilteredFrames: this.state.filteredFrames});
    console.log({PropsFrames: this.props.frames});
    if (!this.state.filteredFrames) {
      return <div className="loading">
        <p>Loading</p>
        <div className="lds-ellipsis">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div></div>
    }
    // note : Chrome can't handle css grid above 1000 elements!
    const begin = this.state.framesPerPage * (this.state.currentPage - 1);
    const end = this.state.framesPerPage * this.state.currentPage;
    const frame_slice = this.state.filteredFrames.slice(begin, end);
    return (
      <div className="paginatedContainer">
        <div className="pagination-top">
          <Paginator onChange={this.changePage} pages={this.state.pages} page={this.state.currentPage}/>
        </div>
        <div className="frameContainer">
          {frame_slice.map(frame => <Frame frame={frame} key={frame.index} index={frame.index}/>)}
        </div>
        <div className="pagination-bot">
          <Paginator onChange={this.changePage} pages={this.state.pages} page={this.state.currentPage}/>
        </div>
      </div>
    );
  }
}

export default FrameContainer;